<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest}>
	<path
		d="M3.6001 19.2795L19.28 3.59961L20.4 4.7196L4.72009 20.3995L3.6001 19.2795Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M4.71997 3.59974L20.3999 19.2796L19.2799 20.3996L3.59998 4.71973L4.71997 3.59974Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
